import * as React from 'react';
import Page from '../../components/Page';
import Loader from '../../components/Loader';
import { ErrorFlash } from '../../components/Flash';
import { ProfileContext, ProfileManager } from '../../profile';
import { useRequest, getHeaders } from '../../api/client';
import SalesReportList from '../../components/SalesReportList';

const reports = (context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: '/store/reports/sales',
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

export default function SalesReports() {
  const context = React.useContext(ProfileContext);
  const state = reports(context);

  if (state.loading) {
    return <Loader />;
  }

  return (
    <Page title="Sales Reports" subtitle="See all sales reports">
      {state.error && <ErrorFlash error={state.error} />}
      <SalesReportList items={state.data || []} />
    </Page>
  );
}
